<div class="distance-filter-container">
  <div class="address-search-wrapper width-100">
    <app-address-search-input [label]="'Address / ZIP Search'" [placeholder]="'Address Search'" [loadAPI]="true"
      [(ngModel)]="proximityAddress" [ngModelOptions]="{ standalone: true }" (addressSelected)="onAddressSelected($event)">
    </app-address-search-input>
  </div>

  <div class="user-filter-section width-100">
    <kendo-formfield class="kendo-formfield left-search-icon multi">
      <kendo-label text="Nearest Investigators" [for]="multiSelect"></kendo-label>
      <div style="position: relative;">
        <i class="fa fa-search" aria-hidden="true"></i>
        <kendo-multiselect #multiSelect [autoClose]="false" [valuePrimitive]="true"
          [data]="filteredUsers" [(ngModel)]="selectedId" [ngModelOptions]="{ standalone: true }" [rounded]="'full'" (valueChange)="toggleUser($event)"
          [kendoDropDownFilter]="{caseSensitive: false, operator: 'startsWith'}" valueField="id"
          textField="itemFullName" [placeholder]="'Search from list'" [fillMode]="'outline'" [filterable]="true" [disabled]="!proximityAddress">

          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <input type="checkbox" class="k-checkbox k-checkbox-md" [checked]="isSelected(dataItem.id)"
              style="margin-right: 8px; pointer-events: none;" />
            <div class="user-label">
              <div class="user-info">
                <span class="user-name">{{ dataItem.itemFullName }} </span>
                <span class="user-location">{{dataItem?.HomeAddress.city + ', ' +
                  dataItem?.HomeAddress?.state}}</span>
              </div>
              <kendo-badge *ngIf="dataItem.distance !== undefined && dataItem.distance !== Infinity"
                class='fw600 assigned-badge' position="none" size="medium" rounded="full" themeColor="tertiary">
                <span> {{ dataItem.distance | number:'1.1-1' }} miles away</span>
              </kendo-badge>
            </div>
          </ng-template>

          <ng-template kendoMultiSelectNoDataTemplate *ngIf="!searchString?.trim()?.length && !loading">
            No staff members found.
          </ng-template>
          <ng-template kendoMultiSelectNoDataTemplate *ngIf="searchString?.trim()?.length && !loading">
            No matches for "{{ searchString }}"
          </ng-template>
        </kendo-multiselect>
      </div>
    </kendo-formfield>
  </div>
</div>
